<template>
    <card-list-item @click="action" :class="{'clickable': clickable}">
        <template v-slot:icon>
            <i class="far fa-fw" :class="icon" v-if="icon"></i>
        </template>
        <template v-slot:content>
            <div class="title">
                {{title}}
            </div>
        </template>
        <template v-slot:badge>
            <span v-if="note" class="note">{{note}}</span>
            <b-button v-if="buttonText" @click="action" variant="white" class="button"><i class="far fa-plus pr-2 text-white" :class="icon" v-if="icon"></i>{{buttonText}}</b-button>
            <b-badge v-if="badge" variant="light">{{badge}}</b-badge>
        </template>

    </card-list-item>
</template>

<script>
    import CardListItem from "./CardListItem";
    export default {
        name: 'SubheaderListItem',
        components: {CardListItem},
        props: {
            title:  String,
            icon: String,
            note: String,
            buttonText: String,
            badge: [String, Number],
            clickable: Boolean
        },
        methods: {
            action: function() {
                if (this.clickable) this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    $color: #3c6286;

    li {
        background-color: $color !important;
        border-bottom: 1px solid $color !important;
        padding: 0.2rem 0 !important;

        cursor: default !important;

        .title {
            font-family: 'Montserrat', sans-serif;
            color: white;
            text-transform: uppercase;
            font-size: 0.75rem !important;
            font-weight: bold;
            letter-spacing: 0.5px;
            padding: 5px 0 3px;
        }

        i {
            font-size: 0.8rem !important;
            color: white;
        }

        &:hover {
            background-color: $color !important;
        }

        &.clickable {
            cursor: pointer;
        }

        .badge {
            margin-top: 2px;
            margin-right: 0
        }

        .button {
            font-size: 12px;
            color: #ffffff
        }

        .note {
            color: #ffffff;
            padding-right: 7px;
            font-size: 10px
        }
    }
</style>
